var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/_has.js
// module id = 6
// module chunks = 0